import React from "react";
import { Button, Container } from "react-bootstrap";
import TopHeader from "../Common/TopHeader";
import "./Reports.css";
import { GetApiMethod } from "../../core/services/apiService";
import TooltipPositioned from "../Tooltip/TooltipPositioned";
import FilterComponent from "../Common/FilterComponent";
import AppModal from "../AppModal/AppModal";
import AppLoader from "../AppLoader/AppLoader";
import { useAppDispatch } from "../../core/redux/hooks";
import { hideToaster, showToaster } from "../../core/redux/toastSlice";
import { PhoneNumberFormatter, CheckPropertyExistOrNot, RemoveExtraCharsFromNumber, DisplayToaster } from "../../core/services/sharedService";
import DataTable from "react-data-table-component";
import AppLoaderTable from "../AppLoader/AppLoaderTable";

const ReportDetails = () => {
    const [data, setData] = React.useState<any>([]);
    // const [totalData, setTotalData] = React.useState([]);
    const [showLoader, setShowLoader] = React.useState(true);
    const [filterText, setFilterText] = React.useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
    const [showReplayModal, setShowReplayModal] = React.useState<boolean>(false);
    const [replayCallReportInfo, setReplayCallReportInfo] = React.useState<any>();
    const [customLoading, setCustomLoading] = React.useState<boolean>(false);
    let replayClickedRowRef = React.useRef<string | null>(null);
    const dispatch = useAppDispatch();

    const [totalRows, setTotalRows] = React.useState(0);
    const [perPage, setPerPage] = React.useState(10);
    const [disableExport, setDisableExport] = React.useState<boolean>(false);
    const [column, setColumn] = React.useState<any>({});
    const [sortDirection, setSortDirection] = React.useState<string>('asc');
    const [startDate, setStartDate] = React.useState<Date | undefined>(
        new Date(new Date()?.setDate(new Date()?.getDate() - 30))
    );
    const [endDate, setEndDate] = React.useState<Date | undefined>(new Date());
    const [page, setPage] = React.useState(1);
    const [currentExpandedRow, setExpandedCurrentRow] = React.useState(null);
    // Report view filter: 'all' (calls + voicemails, default), 'calls', 'voicemails'.
    type VoicemailMode = "all" | "calls" | "voicemails";
    const [voicemailMode, setVoicemailMode] = React.useState<VoicemailMode>("all");

    // isAdminReport only decides which endpoint to hit. The voicemail segmented
    // filter and the Recording column are now shown for agents too (agent
    // voicemails are scoped server-side to calls that agent was rung for).
    const isAdminReport: boolean = process.env.REACT_APP_ADMIN === localStorage.getItem("event");

    const reportUrl: string = isAdminReport
        ? "tenant/report"
        : "tenant/report/agent"

    const formatHoursAMPM = (date: any) => {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        const AmPm = hours >= 12 ? 'pm' : 'am';

        hours %= 12;
        hours = hours || 12;
        minutes = minutes < 10 ? `0${minutes}` : minutes;
        seconds = seconds < 10 ? `0${seconds}` : seconds;

        const strTime = `${hours}:${minutes}:${seconds} ${AmPm}`;

        return strTime;
    };

    let Duration = (date1: any, date2: any) => {
        let difference = date1.getTime() - date2.getTime();
        if (difference > 0) {
            let daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
            difference -= daysDifference * 1000 * 60 * 60 * 24
            let hoursDifference = Math.floor(difference / 1000 / 60 / 60);
            difference -= hoursDifference * 1000 * 60 * 60
            let minutesDifference = Math.floor(difference / 1000 / 60);
            difference -= minutesDifference * 1000 * 60
            let secondsDifference = Math.floor(difference / 1000);
            return (
                hoursDifference + 'h : ' +
                minutesDifference + 'm : ' +
                secondsDifference + "s"
            );
        }
        else {
            return ("-");
        }
    }

    const timeFormat = React.useCallback((date: Date, NoNeedTime?: boolean) => {
        let formattedDate = new Date(date);
        let formattedTime: string = "";
        if (NoNeedTime) {
            formattedTime =
                ("00" + (formattedDate.getMonth() + 1)).slice(-2) +
                "-" +
                ("00" + formattedDate.getDate()).slice(-2) +
                "-" +
                formattedDate.getFullYear()
        } else {
            formattedTime =
                ("00" + (formattedDate.getMonth() + 1)).slice(-2) +
                "-" +
                ("00" + formattedDate.getDate()).slice(-2) +
                "-" +
                formattedDate.getFullYear() +
                " " +
                formatHoursAMPM(formattedDate)
        }
        return formattedTime;
    }, []);

    const [callTypeSelectedValues, setCallTypeSelectedValues] = React.useState<string>("");
    const [callDirectionSelectedValues, setCallDirectionSelectedValues] = React.useState<string>("");
    const [callFromSelectedValues, setCallFromSelectedValues] = React.useState<string>("");
    const [callToSelectedValues, setCallToSelectedValues] = React.useState<string>("");
    const [callForwaredSelectedValues, setCallForwaredSelectedValues] = React.useState<string>("");
    const [AgentSelectedValues, setAgentSelectedValues] = React.useState<string>("");
    const [locationSelectedValues, setLocationSelectedValues] = React.useState<string>("");

    const subHeaderComponent = React.useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };

        return (
            <FilterComponent
                onFilter={(e: any) => { setFilterText(e.target.value); setResetPaginationToggle(!resetPaginationToggle) }}
                onCallTypeSelect={(e: any, filter_type: string) => {
                    (filter_type === "filter_by_type") ? setCallTypeSelectedValues(e.target.value) :
                        (filter_type === "filter_by_call_from") ? setCallFromSelectedValues(e.target.value) :
                            (filter_type === "filter_by_call_to") ? setCallToSelectedValues(e.target.value) :
                                (filter_type === "filter_by_call_forward_to") ? setCallForwaredSelectedValues(e.target.value) :
                                    (filter_type === "filter_by_call_direction") ? setCallDirectionSelectedValues(e.target.value) :
                                        (filter_type === "filter_by_agent") ? setAgentSelectedValues(e.target.value) :
                                            (filter_type === "filter_by_location") ? setLocationSelectedValues(e.target.value) :
                                                setCallTypeSelectedValues(e.target.value)

                }}
                onStart={(e: any) => { (e ? setStartDate(new Date(e.setHours(0, 0, 0, 0))) : setStartDate(undefined)); setResetPaginationToggle(!resetPaginationToggle) }}
                onEnd={(e: any) => { e ? setEndDate(new Date(e.setHours(23, 59, 59, 999))) : setEndDate(new Date()); setResetPaginationToggle(!resetPaginationToggle) }}
                onClear={handleClear}
                filterText={filterText}
                selectStart={startDate}
                selectEnd={endDate}
            />
        );
    }, [endDate, filterText, resetPaginationToggle, startDate]);

    // To fetch the reports from backend
    const fetchReports = React.useCallback(async () => {
        const response = await GetApiMethod(`${reportUrl}`,
            {
                params: {
                    'page': page,
                    'limit': perPage,
                    'search_text': filterText,
                    'sort_by': column?.sortField ? column.sortField : "",
                    'order_by': sortDirection,
                    'start_date': startDate ? startDate : "",
                    'end_date': endDate ? endDate : new Date(),
                    'filter_by_type': callTypeSelectedValues,
                    'filter_by_call_direction': callDirectionSelectedValues,
                    'filter_by_call_from': callFromSelectedValues,
                    'filter_by_call_to': callToSelectedValues,
                    'filter_by_call_forward_to': callForwaredSelectedValues,
                    'filter_by_agent': AgentSelectedValues,
                    'filter_by_location': locationSelectedValues,
                    'voicemail_mode': voicemailMode
                }
            }
        );
        if (response) {
            setShowLoader(false);
        }
        setData(response.data.data.reports);
        setTotalRows(response.data.data.total_count);
    }, [reportUrl, page, perPage, filterText, column.sortField, sortDirection, startDate, endDate, callTypeSelectedValues, callDirectionSelectedValues, callFromSelectedValues, callToSelectedValues, callForwaredSelectedValues, AgentSelectedValues, locationSelectedValues, voicemailMode]);

    // To implement server side sorting
    const handleSort = React.useCallback((column: any, sortDirection: any) => {
        setColumn(column);
        setSortDirection(sortDirection);
    }, []);

    React.useEffect(() => {
        fetchReports();
    }, [fetchReports]);

    // To get the data when user click next page
    const handlePageChange = React.useCallback((page: any) => {
        setPage(page);
    }, []);

    function capitalizeFirstLetter(string: string) {
        if (string)
            return string[0].toUpperCase() + string.slice(1);
    }

    let calcDuration = (date1: any, date2: any) => {
        let difference = date1?.getTime() - date2?.getTime();
        if (difference > 0) {
            let secondsDifference = Math.floor(difference / 1000);
            return (secondsDifference);
        }
        else {
            return ("-");
        }
    }

    const checkValueIsPhoneNumber = React.useCallback((value: string) => {
        const phoneNumber = value.replace(/\D/g, '');
        if (phoneNumber && phoneNumber.length >= 10 && phoneNumber.length < 12) {
            if (phoneNumber.length === 10) {
                return PhoneNumberFormatter(phoneNumber.toString(), phoneNumber.toString().length);
            }
            return PhoneNumberFormatter(phoneNumber.toString().slice(1), phoneNumber.toString().slice(1).length);
        }
        else
            return value;
    }, []);


    const downloadCSV = React.useCallback(async () => {
        try {
            let totalReportsArray = [];
            setDisableExport(true);
            let getTotalReports: any;
            if (totalRows <= 0) {
                setDisableExport(false);
                DisplayToaster("bg-danger", "There are no records to export")
            } else {
                getTotalReports = await GetApiMethod(`${reportUrl}`, {
                    params: {
                        'page': 1,
                        'limit': totalRows,
                        'search_text': filterText,
                        'sort_by': column?.sortField ? column.sortField : "",
                        'order_by': sortDirection,
                        'start_date': startDate ? startDate : "",
                        'end_date': endDate ? endDate : new Date(),
                        'filter_by_type': callTypeSelectedValues,
                        'filter_by_call_direction': callDirectionSelectedValues,
                        'filter_by_call_from': callFromSelectedValues,
                        'filter_by_call_to': callToSelectedValues,
                        'filter_by_call_forward_to': callForwaredSelectedValues,
                        'filter_by_agent': AgentSelectedValues,
                        'filter_by_location': locationSelectedValues,
                        'voicemail_mode': voicemailMode
                    }
                });
                totalReportsArray = getTotalReports.data.data.reports;
                if (getTotalReports.data.status) {
                    setDisableExport(false);
                }
            }

            const link = document.createElement('a');
            let csvArray: {
                call_type: 'string',
                agent: 'string',
                location: 'string | undefined',
                call_from: 'string | undefined',
                call_to: 'string | undefined',
                call_forward_to: 'string | undefined',
                initiated: 'string',
                acknowledged: 'string | undefined',
                call_direction: 'string | undefined',
                duration: 'string | undefined',
                durationInseconds: 'string | undefined',
                IVRPayment: 'string | undefined',
                // call_sid: 'string | undefined'         // added call_sid since it helps to total missed call count 
            }[] = [];

            let missed_call_count = 0;
            let missedCallLabels = ["missed call", "Missed Call - No Agents", "call forwarded"];

            totalReportsArray.forEach((innerData: any) => {
                const isMissed = missedCallLabels?.includes(madeFinalCallDirection(innerData));
                if (isMissed) missed_call_count++;
                innerData.data.forEach((item: any) => {
                    let newObj: any = {};
                    newObj['Call type'] = item.type;
                    if ('agent' in item && item.agent) {
                        newObj['Agent'] = (item.agent[0] && 'name' in item.agent[0]) ? item.agent[0].name : "-";
                    } else {
                        newObj['Agent'] = "-";
                    }
                    if ('location' in item && item.location && item.location[0]?.name) {
                        newObj['Location'] = item.location[0].name ? item.location[0].name : "-";
                    } else {
                        newObj['Location'] = "-";
                    }
                    //newObj['Call From'] = item.call_from ? PhoneNumberFormatter(item.call_from.toString().slice(1), item.call_from.toString().slice(1).length) : "-";
                    newObj['Call From'] = /^\d/.test(item.call_from) ? PhoneNumberFormatter(item.call_from.toString().slice(1), item.call_from.toString().slice(1).length) : item.call_from || "-";
                    // newObj['Call To'] = item.call_to ? PhoneNumberFormatter(item.call_to.toString().slice(1), item.call_to.toString().slice(1).length) : "-";
                    newObj['Call To'] = item.call_to ? checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(item.call_to?.toString())) : "-";
                    newObj['Call Forward Number'] = item.call_forward_to ? PhoneNumberFormatter(item.call_forward_to.toString().slice(1), item.call_forward_to.toString().slice(1).length) : "-";
                    newObj['Initiated Time'] = item.initiated ? timeFormat(item.initiated) : "-";
                    newObj['Acknowledged Time'] = item.acknowledged ? timeFormat(item.acknowledged) : "-";
                    newObj['Call Direction'] = item.call_direction ? capitalizeFirstLetter(item.call_direction) : "-";
                    newObj['Duration'] = Duration(new Date(item.end), new Date(item.start));
                    newObj['Duration In seconds'] = calcDuration(new Date(item.end), new Date(item.start));
                    newObj['Call Status'] = isMissed ? "Missed" : "Answered";
                    newObj['IVR-Payment'] = item.callTreeChoice === "IVR Payment" ? (item.callTreeChoice_forward_number ? checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(item.callTreeChoice_forward_number)) : "-") : "-";
                    // newObj['call_sid'] = item.call_sid           // added call_sid since it helps to total missed call count 
                    csvArray.push(newObj);
                });
            });

            let csv = convertArrayOfObjectsToCSV(csvArray);
            const headerLine = `, , ,,,TOTAL MISSED CALLS,${missed_call_count}`;
            csv = `${headerLine}\n\n\n${csv}`;
            if (csv == null) return;
            const filename = `RCM-Report-${timeFormat(new Date(), true)}.csv`;
            if (!csv.match(/^data:text\/csv/i)) {
                csv = `data:text/csv;charset=utf-8,${csv}`;

            }
            link.setAttribute('href', encodeURI(csv));
            link.setAttribute('download', filename);
            link.click();
        } catch (error) {
            DisplayToaster("bg-danger", "Failed to export data");
            console.error("Export CSV Error:", error);
        }
    }, [AgentSelectedValues, callDirectionSelectedValues, callForwaredSelectedValues, callFromSelectedValues, callToSelectedValues, callTypeSelectedValues, column.sortField, endDate, filterText, locationSelectedValues, reportUrl, sortDirection, startDate, timeFormat, totalRows, checkValueIsPhoneNumber, voicemailMode]);

    const Export: any = React.useCallback(
        ({ onExport }: any) => (
            <Button
                disabled={disableExport}
                className="app-button-color"
                onClick={(e) => onExport((e.target as HTMLButtonElement).value)}
            >
                {disableExport && (
                    <span
                        className="spinner-border text-white mr-1"
                        style={{ width: "18px", height: "18px" }}
                        role="status"
                    ></span>
                )}{" "}
                Export
            </Button>
        ),
        [disableExport]
    );

    const ExportCSV = React.useMemo(
        () => <Export onExport={() => downloadCSV()} />,
        [downloadCSV, Export]
    );

    const voicemailModeHandler = React.useCallback((mode: VoicemailMode) => {
        setVoicemailMode((prev) => (prev === mode ? prev : mode));
        setPage(1);
        setResetPaginationToggle((prev) => !prev);
    }, []);

    const ReportActions = React.useMemo(() => {
        const segments: { key: VoicemailMode; label: string; icon: string }[] = [
            { key: "all", label: "All", icon: "bi-collection" },
            { key: "calls", label: "Calls", icon: "bi-telephone" },
            { key: "voicemails", label: "Voicemails", icon: "bi-voicemail" },
        ];
        return (
            <div className="report-actions">
                <div className="vm-seg" role="tablist" aria-label="Filter records by type">
                    {segments.map((s) => (
                        <button
                            key={s.key}
                            type="button"
                            role="tab"
                            aria-selected={voicemailMode === s.key}
                            className={`vm-seg-btn ${voicemailMode === s.key ? "is-active" : ""}`}
                            onClick={() => voicemailModeHandler(s.key)}
                        >
                            <i className={`bi ${s.icon}`} />
                            <span>{s.label}</span>
                        </button>
                    ))}
                </div>
                {ExportCSV}
            </div>
        );
    }, [voicemailMode, voicemailModeHandler, ExportCSV]);

    const convertArrayOfObjectsToCSV = (array: any) => {
        let result: any;

        const columnDelimiter = ',';
        const lineDelimiter = '\n';
        const keys = Object.keys(array[0]);

        result = '';
        result += keys.join(columnDelimiter);
        result += lineDelimiter;

        array.forEach((item: any) => {
            let ctr = 0;
            keys.forEach(key => {
                if (ctr > 0) result += columnDelimiter;
                result += item[key];
                ctr++;
            });
            result += lineDelimiter;
        });

        return result;
    }

    const madeFinalCallDirection = (rowData: any) => {
        const callDirections = rowData?.data?.map((item: any) => item.call_direction).filter(Boolean);
        const preferredOrder = [
            "voicemail",
            "restart motion",
            "outgoing call",
            "agent call",
            "incoming call",
            "do not disturb",
            "call forwarded",
            "missed call",
            "Missed Call - No Agents"
        ];
        const resultDirection = preferredOrder?.find(direction => callDirections?.includes(direction)) || "missed call";
        return resultDirection;
    }

    const callDirectionView = (row: any) => {

        let FinalCallDirectionView = madeFinalCallDirection(row);

        return (
            <div>
                {capitalizeFirstLetter(
                    FinalCallDirectionView
                ) === "Restart motion" && (
                        <i className="bi bi-arrow-clockwise pr-2"></i>
                    )}
                {capitalizeFirstLetter(
                    FinalCallDirectionView
                ) === "Do not disturb" && (
                        <i className="fa fa-ban pr-2"></i>
                    )}
                {capitalizeFirstLetter(FinalCallDirectionView) === "Missed call" || FinalCallDirectionView === "Missed Call - No Agents" ? (
                    <i className="bi bi-x-lg pr-2"></i>
                ) : (<></>)}
                {capitalizeFirstLetter(
                    FinalCallDirectionView
                ) === "Incoming call" && <i className="bi bi-arrow-down pr-2"></i>}
                {capitalizeFirstLetter(
                    FinalCallDirectionView
                ) === "Outgoing call" && <i className="bi bi-arrow-up pr-2"></i>}
                {
                    capitalizeFirstLetter(FinalCallDirectionView) === "Agent call" &&
                    <i className="bi bi-arrow-up pr-2"></i>
                }
                {(capitalizeFirstLetter(FinalCallDirectionView) === "Call forwarded" || capitalizeFirstLetter(FinalCallDirectionView)?.includes("Call forwarded -")) && (
                    <i className="bi bi-arrow-right pr-2"></i>
                )}
                {capitalizeFirstLetter(FinalCallDirectionView) === "Voicemail" && (
                    <i className="bi bi-voicemail pr-2"></i>
                )}
                {capitalizeFirstLetter(
                    FinalCallDirectionView
                )}
            </div>
        );
    };

    const callTypeView = (row: any) => {
        return (
            <div>
                {capitalizeFirstLetter(CheckPropertyExistOrNot(row, "type")) ===
                    "Video" ? (
                    <i className="bi bi-camera-video-fill pr-2"></i>
                ) : (
                    <i className="bi bi-telephone-fill pr-2"></i>
                )}
                {capitalizeFirstLetter(CheckPropertyExistOrNot(row, "type"))}
            </div>
        );
    };

    const initiatedTimeView = (row: any) => {
        return (
            <div>
                {TooltipPositioned({
                    placement: "top",
                    item:
                        CheckPropertyExistOrNot(row, "initiated") !== "-"
                            ? timeFormat(CheckPropertyExistOrNot(row, "initiated"))
                            : "-",
                })}
            </div>
        );
    };

    const ackTimeView = (row: any) => {
        let acknowledged_record = row.filter((item: any) => ((('acknowledged' in item && item.acknowledged !== null) && item.acknowledged) || ('initiated' in item && item.call_direction === "outgoing call")));
        return (
            <div>
                {TooltipPositioned({
                    placement: "top",
                    item:
                        acknowledged_record[0]
                            ? timeFormat(
                                (acknowledged_record[0].acknowledged ? acknowledged_record[0].acknowledged : acknowledged_record[0].initiated)
                            )
                            : "-",
                })}
            </div>
        );
    };

    const playCallRecordings = React.useCallback((isCallRecordingReady: string | null = null) => {
        if (isCallRecordingReady) {
            dispatch(hideToaster());
            setShowReplayModal(true);
        } else {
            setShowReplayModal(false);
            dispatch(showToaster(
                {
                    dialogBgColor: "bg-danger",
                    dialogMsg: "We are saving the call recording. Kindly check after few minutes.",
                    showDialog: true,
                    timer: '10000'
                }
            ));
            replayClickedRowRef.current = null;
        }
        setCustomLoading(false);
    }, []);

    const doubleEncodeId = (id: any) => {
        const firstEncoding = encodeURIComponent(id);
        const doubleEncodedId = encodeURIComponent(firstEncoding);
        return doubleEncodedId;
    }

    const getCallRecordings = React.useCallback((row: any, isDownload = false) => {
        let acknowledgedRecord = row?.data?.filter((item: any) => ((('acknowledged' in item && item?.acknowledged !== null) && item?.acknowledged) || (('start' in item && 'end' in item) && item?.call_direction === "outgoing call")));
        replayClickedRowRef.current = (row && row?._id && 'call_sid' in row?._id) ? row?._id?._call_sid : null;
        setCustomLoading(true);
        let encodedId = (row._id?.call_sid.includes("/") || row._id?.call_sid.includes("+")) ? doubleEncodeId(row._id?.call_sid) : row._id?.call_sid;
        // A voicemail can share its call_sid with the paired missed-call report.
        // Tell the API which one was clicked so it resolves the voicemail's
        // recording instead of the report's (which has no mediaUrl).
        const isVoicemailRow = row?.source === "voicemail" || madeFinalCallDirection(row) === "voicemail";
        const recordingBase = isAdminReport
            ? 'tenant/report/get-recording/'
            : 'tenant/report/agent/get-recording/';
        const recordingUrl = recordingBase + encodedId + "/" + row?._id.type
            + (isVoicemailRow ? "?source=voicemail" : "");
        GetApiMethod(recordingUrl).then((res) => {

            if (res && res.data && res.data.data && res.data.data.mediaUrl) {
                if (!isDownload) {
                    var ackInfo: any = {};
                    ackInfo["appendAcknowledgeInfo"] = [];
                    res.data.appendAcknowledgeInfo = acknowledgedRecord;
                    setReplayCallReportInfo(res?.data);
                    playCallRecordings(res?.data?.data?.mediaUrl);
                } else {
                    window.open(res.data?.data?.mediaUrl, '_blank');
                }
            } else {
                playCallRecordings();
            }
        });
    }, [])

    const actionView = (row: any) => {
        const finalDir = madeFinalCallDirection(row);
        const isVoicemailRow = row?.source === "voicemail" || finalDir === "voicemail";
        // Agent login: only voicemail rows are playable/downloadable; every
        // other call direction shows "-". Admin keeps full recording access.
        const canPlayRecording = isAdminReport
            ? (finalDir !== "restart motion" && finalDir !== "do not disturb" && finalDir !== "missed call" && finalDir !== "call forwarded" && finalDir !== "Missed Call - No Agents")
            : isVoicemailRow;
        return (
            <>
                {customLoading &&
                    replayClickedRowRef.current &&
                    replayClickedRowRef.current === row._id?.call_sid ? (
                    <AppLoader removeFixedHeight={true} customClassName={"ml-3"} />
                ) : (
                    <div
                        className="cursor-pointer"
                    >

                        {
                            canPlayRecording ?
                                <>
                                    <i
                                        className="bi bi-play-fill ml-2"
                                        title='Play'
                                        style={{ fontSize: 24 }}
                                        onClick={() => {
                                            if (
                                                madeFinalCallDirection(row) === "missed call" ||
                                                madeFinalCallDirection(row) === "restart motion"
                                            ) {
                                                // return;
                                                getCallRecordings(row);
                                            }
                                            if (!customLoading) {
                                                getCallRecordings(row);
                                            }
                                        }}
                                    ></i>
                                    <i
                                        className="bi bi-download ml-2"
                                        title='Download'
                                        style={{ fontSize: 24 }}
                                        onClick={() => {
                                            if (
                                                madeFinalCallDirection(row) === "missed call" ||
                                                madeFinalCallDirection(row) === "restart motion"
                                            ) {
                                                // return;
                                                getCallRecordings(row, true);
                                            }
                                            if (!customLoading) {
                                                getCallRecordings(row, true);
                                            }
                                        }}
                                    ></i>
                                </> : "-"
                        }

                    </div>
                )}
            </>
        );
    };

    const [columns, setColumns] = React.useState<any>(
        [
            {
                name: "Call Type",
                selector: (row: any) => capitalizeFirstLetter((CheckPropertyExistOrNot(row.data[0], 'type'))),
                sortable: true,
                cell: (row: any) => (
                    callTypeView(row.data[0])
                ),
                id: "call_type",
                sortField: 'type',
            },
            {
                name: "Call Direction",
                width: '180px',
                selector: (row: any) => capitalizeFirstLetter((CheckPropertyExistOrNot(row, 'call_direction'))),
                sortable: true,
                // cell: (row: any) => (
                //     callDirectionView(row)
                // ),
                cell: (row: any) => (
                    <span className={madeFinalCallDirection(row) === "missed call" || madeFinalCallDirection(row) === "Missed Call - No Agents" ? "text-danger" : ""}>
                        {callDirectionView(row)}
                    </span>
                ),
                // cell: (row: any) => (capitalizeFirstLetter(row.data[0].call_direction)),
                id: 'call_direction',
                sortField: 'call_direction',
            },
            // {
            //     name: "Agent",
            //     selector: (row: any) => (('agent' in row.data[0] && row.data[0].agent[0] && row.data[0].agent[0].name) ?
            //         TooltipPositioned({
            //             'placement': 'top',
            //             'item': row.data[0].agent[0].name
            //         })
            //         : "-"),
            //     sortable: true,
            //     id: 'agent',
            //     sortField: 'agent',
            // },
            {
                name: "Location",
                // selector: (row: any) => (('location' in row && row.location[0] && row.location[0].name) ? row.location[0].name : "-"),
                selector: (row: any) => (('location' in row.data[0] && row.data[0].location[0] && row.data[0].location[0].name) ? TooltipPositioned({ 'placement': 'top', 'item': row.data[0].location[0].name }) : "-"),
                sortable: true,
                id: 'location',
                sortField: 'location',
            },
            {
                name: "Call From",
                selector: (row: any) => (CheckPropertyExistOrNot(row.data[0], 'call_from') !== "-" ?
                    TooltipPositioned({
                        'placement': 'top',
                        'item': (row.data[0].type === "voice" ? checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(row.data[0].call_from.toString())) :
                            (madeFinalCallDirection(row) !== "outgoing call" ? capitalizeFirstLetter(row.data[0].call_from) : "-"))
                    })
                    : "-"),
                sortable: true,
                id: 'call_from',
                sortField: 'call_from',
            },
            {
                name: "Call To",
                selector: (row: any) => (CheckPropertyExistOrNot(row.data[0], "call_to") !== "-" ?
                    TooltipPositioned({
                        'placement': 'top',
                        item: checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(row.data[0].call_to.toString())),
                    })
                    : "-"),
                sortable: true,
                id: 'call_to',
                sortField: 'call_to',
            },
            {
                name: "Call Forward Number",
                selector: (row: any) => (CheckPropertyExistOrNot(row.data[0], "call_forward_to") !== "-" ?
                    TooltipPositioned({
                        'placement': 'top', 'item':
                            (PhoneNumberFormatter(RemoveExtraCharsFromNumber(row.data[0].call_forward_to.toString()).slice(1), RemoveExtraCharsFromNumber(row.data[0].call_forward_to.toString()).slice(1).length))
                    }) : "-"),
                sortable: true,
                id: 'call_forward_to',
                sortField: 'call_forward_to',
            },
            {
                name: "Initiated Time",
                width: '200px',
                selector: (row: any) => (timeFormat(CheckPropertyExistOrNot(row.data[0], 'initiated'))),
                cell: (row: any) => (
                    initiatedTimeView(row.data[0])
                ),
                sortable: true,
                id: 'initiated',
                sortField: 'initiated',
            },
            {
                name: "Acknowledged Time",
                width: '200px',
                selector: (row: any) => (timeFormat(CheckPropertyExistOrNot(row, 'acknowledged'))),
                cell: (row: any) => ackTimeView(row.data),
                id: 'acknowledged',
                sortField: 'acknowledged',
                sortable: true
            },
            // {
            //     name: "Call Duration",
            //     selector: (row: any) => (((row.data[0].hasOwnProperty('end') && row.data[0].hasOwnProperty('start')) ? (Duration(new Date(row.data[0].end), new Date(row.data[0].start))) : "-")
            //     ),
            //     sortable: false,
            // },
        ]
    );

    React.useEffect(() => {
        // Recording column (play/download) is shown for both admin and agent —
        // voicemail rows carry a mediaUrl regardless of who is viewing.
        setColumns((oldArray: any) => {
            let newColumnValue = [...oldArray];
            let recordingColumn = {
                name: "Recording",
                selector: (row: any) => CheckPropertyExistOrNot(row.data[0], "action"),
                sortable: false,
                cell: (row: any) => actionView(row),
            };
            if (!newColumnValue.find((x: any) => x.name === "Recording")) {
                newColumnValue.push(recordingColumn);
            }
            return newColumnValue;
        });
    }, []);

    // To handle when user change per page value
    const handlePerRowsChange = React.useCallback(async (newPerPage: any, page: any) => {
        setPerPage(newPerPage);
        setResetPaginationToggle(!resetPaginationToggle);
    }, [resetPaginationToggle]);

    const ExpandedComponents = React.useCallback(({ data }: any) => {
        let acknowledgedRecord = data.data.filter((item: any) => ((('acknowledged' in item && item.acknowledged !== null) && item.acknowledged) || (('start' in item && 'end' in item) && item.call_direction === "outgoing call")));
        let DataArray: {
            "agent": string[],
            'location': string[],
            "call_direction": string[],
            "callHandOff_number": string[],
            "initiated_time": string[],
            "Acknowledged_time": string[],
            "Duration": string[],
            "call_forward_to": string[],
            "agentAndIntiatedTime": string[],
            "call_from_for_voiceCall": any,
            "call_to_for_voiceCall": any,
            "notification": string[],
            "dndDuration": string[],
            'callTreeChoice': string[],
            'contactNum_location': string[],
            'callTreeChoice_forward_number': any[]

        } = {
            'agent': [],
            'location': [],
            'call_direction': [],
            'callHandOff_number': [],
            'initiated_time': [],
            'Acknowledged_time': [],
            'Duration': [],
            'call_forward_to': [],
            'agentAndIntiatedTime': [],
            "call_from_for_voiceCall": [],
            "call_to_for_voiceCall": [],
            "notification": [],
            "dndDuration": [],
            "callTreeChoice": [],
            'contactNum_location': [],
            'callTreeChoice_forward_number': []
        }

        let total_no_of_agents: number = data.total_count;

        data.data.forEach((item: any) => {
            DataArray['agent'].push(('agent' in item && item.agent[0] && 'name' in item.agent[0]) && capitalizeFirstLetter(item.agent[0].name));
            DataArray['location'].push(('location' in item && item.location[0] && 'name' in item.location[0]) && item.location[0].name);
            DataArray['call_direction'].push(('call_direction' in item) && item.call_direction);
            ('callHandOff_number' in item) && DataArray['callHandOff_number'].push(item.callHandOff_number);
            DataArray['notification'].push(('notification' in item) && item.notification);
            DataArray['initiated_time'].push(('initiated' in item) && item.initiated);
            DataArray['Acknowledged_time'].push(('acknowledged' in item) && item.acknowledged);
            (('call_forward_to' in item) && DataArray['call_forward_to'].indexOf(item.call_forward_to) === -1) && DataArray['call_forward_to'].push(item.call_forward_to);
            DataArray['Duration'].push((item.start && item.end) && (Duration(new Date(item.end), new Date(item.start))))
            DataArray['agentAndIntiatedTime'].push((item.agent[0]?.name ? capitalizeFirstLetter(item.agent[0]?.name) : "Other Agents") + " -- " + (item.initiated ? timeFormat(item.initiated) : "-"))
            DataArray['call_from_for_voiceCall'].push('call_from' in item ? (item.call_type === "video" ? item.call_from : checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(item.call_from.toString()))) : "-")
            DataArray['call_to_for_voiceCall'].push('call_to' in item ? checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(item.call_to.toString())) : "-")
            DataArray['dndDuration'].push('duration' in item && item.duration);
            (('callTreeChoice' in item) && DataArray['callTreeChoice'].push('callTreeChoice' in item && item.callTreeChoice));
            (('contactNum_location' in item) && DataArray['contactNum_location'].push('contactNum_location' in item && item.contactNum_location));
            (('callTreeChoice_forward_number' in item) && DataArray['callTreeChoice_forward_number'].push(('callTreeChoice_forward_number' in item) && checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(item.callTreeChoice_forward_number?.toString()))))
        });

        let FinalCallDirection = madeFinalCallDirection(data);

        return (

            <table className="table table-bordered m-3" style={{ width: '100%', maxWidth: '50%' }} >
                <thead className="table-primary text-center">
                    <tr>
                        <td><b>Call Type - {capitalizeFirstLetter(data._id?.type)}</b></td>
                        {
                            <td><b>{capitalizeFirstLetter(FinalCallDirection)}</b></td>
                        }
                    </tr>
                </thead>
                <tbody className="">
                    <tr>
                        <td><b>{((FinalCallDirection === "do not disturb" || FinalCallDirection === "restart motion") && DataArray['notification'].toString() === "false") ? "Location" : "Call From"} </b></td>
                        {
                            data._id?.type === "video" ?
                                (FinalCallDirection !== "outgoing call" ? <td>{capitalizeFirstLetter(DataArray['call_from_for_voiceCall'][0])} - {DataArray['location'][0]}</td> : <td>{DataArray['agentAndIntiatedTime'][0]}</td>)
                                :
                                <td>{FinalCallDirection === "outgoing call" ? ((DataArray['agent'][0]) + " -- " + DataArray['call_from_for_voiceCall'][0]) : DataArray['call_from_for_voiceCall'][0]}</td>
                        }
                    </tr>

                    {
                        (data._id?.type === "voice" && !(DataArray['callTreeChoice'].length > 0)) ?
                            <tr>
                                <td><b>Call To</b></td>
                                <td>
                                    {
                                        FinalCallDirection === "outgoing call" ?
                                            DataArray['call_to_for_voiceCall'][0] :
                                            (
                                                DataArray['location'][0] ? (DataArray['location'][0] + " -- " + DataArray['call_to_for_voiceCall'][0]) : DataArray['call_to_for_voiceCall'][0]
                                            )
                                    }
                                </td>
                            </tr>
                            :
                            FinalCallDirection === "outgoing call" &&
                            <tr>
                                <td><b>Call To</b></td>
                                <td>kiosk -- {DataArray['location'][0]}</td>
                            </tr>
                    }

                    {
                        (data._id?.type === "voice" && (DataArray['callTreeChoice'].length > 0)) &&
                        <>
                            <tr>
                                <td><b>Call To</b></td>
                                <td>{DataArray['contactNum_location'][0] + " -- " + DataArray['call_to_for_voiceCall'][0]}</td>
                            </tr>
                            <tr>
                                <td><b>Call Tree Choice</b></td>
                                <td>{DataArray['callTreeChoice'][0]}</td>
                            </tr>
                            <tr>
                                <td><b>Call Tree selected choice</b></td>
                                <td>{DataArray['callTreeChoice'][0] === "location" ? DataArray['location'][0] : DataArray['callTreeChoice_forward_number'][0]}</td>
                            </tr>
                        </>

                    }

                    {
                        FinalCallDirection === "agent call" &&

                        data.data.map((item: any, index: number) => (

                            <>
                                {
                                    (item.call_direction === "conference call") &&
                                    <tr>
                                        <td><b>{index === 0 ? (item.call_direction !== "conference call" ? "Sent To Agent" : "Add Agent") : (item.call_direction !== "conference call" ? "Forwarded To" : "Add Agent")}</b></td>
                                        <td>{capitalizeFirstLetter(item?.agent[0]?.name) + " -- " + (item?.initiated ? timeFormat(item.initiated) : "-")}</td>
                                    </tr>
                                }

                                {
                                    (item.acknowledged && item.call_direction !== "missed call" && item.call_direction !== "agent call") &&
                                    <tr>
                                        <td><b>Acknowledged By</b></td>
                                        <td>{capitalizeFirstLetter(item?.agent[0].name) + " -- " + (item?.acknowledged ? timeFormat(item.acknowledged) : "NA")}</td>
                                    </tr>
                                }

                            </>
                        ))

                    }


                    {
                        FinalCallDirection !== "agent call" && FinalCallDirection !== "Missed Call - No Agents" &&
                        data.data.map((item: any, index: number) => (

                            <>
                                {
                                    (item.call_direction !== "outgoing call" && DataArray['notification'].toString() !== "false") &&
                                    <tr>
                                        <td><b>{index === 0 ? (item.call_direction !== "conference call" ? "Sent To Agent" : "Add Agent") : (item.call_direction !== "conference call" ? "Forwarded To" : "Add Agent")}</b></td>
                                        <td>{capitalizeFirstLetter(item.agent[0]?.name ? item.agent[0]?.name : "other Agents") + " -- " + (item.initiated ? timeFormat(item.initiated) : "-")}</td>
                                    </tr>
                                }

                                {
                                    item.acknowledged && FinalCallDirection !== "missed call" &&
                                    <tr>
                                        <td><b>{item.call_direction === "restart motion" ? "Kiosk Reset By" : item.call_direction === "do not disturb" ? "DND initiated By " : (item.call_direction === "outgoing call" && item.type === "voice") ? "Acknowledged" : "Acknowledged By"}</b></td>
                                        <td>
                                            {
                                                (item.call_direction === "outgoing call" && item.type === "voice") ?
                                                    (item.acknowledged ? timeFormat(item.acknowledged) : "NA") :
                                                    capitalizeFirstLetter(item.agent[0]?.name ? item.agent[0]?.name : "other Agents") + " -- " + (item.acknowledged ? timeFormat(item.acknowledged) : "NA")
                                            }
                                        </td>
                                    </tr>
                                }

                            </>
                        ))
                    }

                    {(data._id?.type === "video" && (DataArray['callHandOff_number'].length > 0)) &&
                        <>
                            <tr>
                                <td><b>Call Hand-off Number</b></td>

                                <td>{(PhoneNumberFormatter(RemoveExtraCharsFromNumber(DataArray['callHandOff_number'][0]?.toString()).slice(1), RemoveExtraCharsFromNumber(DataArray['callHandOff_number'][0]?.toString()).slice(1).length))}</td>
                            </tr>
                        </>
                    }


                    {/* {
                        (FinalCallDirection !== "outgoing call" && FinalCallDirection !== "agent call" && DataArray['notification'].toString() !== "false") &&
                        <tr>
                            <td><b>Sent To Agent</b></td>
                            <td>{DataArray['agentAndIntiatedTime'][0]}</td>
                        </tr>
                    }

                    {
                        [...Array(total_no_of_agents - 1)].map((e, i) => <tr key={i + 1}>
                            <td><b>{DataArray['call_direction'][i + 1] === "conference call" ? "Add Agent" : "Forwarded To"}</b></td>
                            <td>{DataArray['agentAndIntiatedTime'][i + 1]}</td>
                        </tr>)
                    } */}

                    {/* {
                        (FinalCallDirection !== "call forwarded" && FinalCallDirection !== "missed call") &&
                        <tr>
                            <td><b>{(FinalCallDirection === "restart motion" ? "Kiosk Reset Time" : "Acknowledged Byssss")}</b></td>

                            {acknowledgedRecord.map((item: any, index: number) => (
                                <tr key={index}>
                                    <td key={index} >
                                        {capitalizeFirstLetter(item.agent[0].name) + " -- " + (item.acknowledged ? timeFormat(item.acknowledged) : "NA")}
                                    </td>
                                </tr>
                            ))}
                        </tr>
                    } */}

                    {

                        (FinalCallDirection === "restart motion" || FinalCallDirection === "do not disturb" || FinalCallDirection === "missed call" || FinalCallDirection === "call forwarded") ?
                            (FinalCallDirection === "do not disturb" && DataArray['dndDuration']) &&
                            <tr>
                                <td><b>DND Duration (Minutes)</b></td>
                                <td>{DataArray['dndDuration']}</td>

                            </tr> :
                            <tr>
                                {
                                    !(DataArray['callTreeChoice_forward_number'].length > 0) && FinalCallDirection !== "Missed Call - No Agents" &&
                                    <>
                                        <td><b>Call Duration</b></td>

                                        {acknowledgedRecord.map((item: any, index: number) => (
                                            <tr key={index}>
                                                <td key={index}>

                                                    {('start' in item && 'end' in item) && capitalizeFirstLetter(item.agent[0].name) + " -- " + Duration(new Date(item.end), new Date(item.start))}

                                                </td>
                                            </tr>

                                        ))}
                                    </>

                                }

                            </tr>

                    }

                    {

                        (FinalCallDirection === "call forwarded") &&
                        <tr><td><b>Call Forwarded To</b></td>
                            {DataArray['call_forward_to'].map((item: any, i: number) => (
                                <tr key={i} style={{ border: "none" }}>
                                    <td key={i} style={{ border: "none" }}>
                                        {item ? checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(item.toString())) : "-"}
                                    </td>
                                </tr>
                            ))}
                        </tr>

                    }

                    {
                        FinalCallDirection === "voicemail" &&
                        <tr>
                            <td><b>Transcription Text</b></td>
                            <td>{data?.data?.[0]?.transcriptionText ? data.data[0].transcriptionText : "We are saving the voicemail transcription. Kindly check after a few minutes"}</td>
                        </tr>
                    }
                </tbody>
            </table >


            // <table className="table table-bordered m-3" style={{ width: '100%', maxWidth: totalCountDynamicWidth(total_no_of_agents) }} >
            //     <thead className="table-primary text-center">
            //         <tr>
            //             <td><b>Data</b></td>
            //             {
            //                 DataArray['agent'].map((item: any, i: number) => (
            //                     <td key={i}><b>{item ? capitalizeFirstLetter(item) : "Other Agents"}</b></td>
            //                 ))
            //             }
            //         </tr>
            //     </thead>
            //     <tbody className="">
            //         <tr><td><b>Call Direction</b></td>{DataArray['call_direction'].map((item: any, i: number) => (<td key={i}>{capitalizeFirstLetter(item)}</td>))}</tr>
            //         <tr><td><b>Initiated Time</b></td>{DataArray['initiated_time'].map((item: any, i: number) => (<td key={i}>{timeFormat(item)}</td>))}</tr>
            //         <tr><td><b>Acknowledged Time</b></td>{DataArray['Acknowledged_time'].map((item: any, i: number) => (<td key={i}>{item ? timeFormat(item) : "-"}</td>))}</tr>
            //         <tr><td><b>Duration</b></td>{DataArray['Duration'].map((item: any, i: number) => (<td key={i}>{item ? item : "-"}</td>))}</tr>
            //         <tr><td><b>Call Forward Number</b></td>{DataArray['call_forward_to'].map((item: any, i: number) => (<td key={i}>{item ? checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(item.toString())) : "-"}</td>))}</tr>
            //     </tbody>
            // </table>

            // <table className="table table-secondary table-bordered m-1" >
            //     <thead className="table-primary">
            //         <tr>
            //             <td>Call Type</td>
            //             <td>Agent</td>
            //             <td>Call Direction</td>
            //             <td>Location</td>
            //             <td>Call From</td>
            //             <td>Call To</td>
            //             <td>Call Forward Number</td>
            //             <td>Intiated Time</td>
            //             <td>Acknowledged Time</td>
            //             <td>Call Duration</td>
            //         </tr>
            //     </thead>

            //     <tbody>
            //         {data.data.map((innerData: any) => (
            //             <>
            //                 <tr>
            //                     <td>{innerData.type}</td>
            //                     <td>{('agent' in innerData && innerData.agent[0] && 'name' in innerData.agent[0]) && innerData.agent[0].name}</td>
            //                     <td>{innerData.call_direction}</td>
            //                     <td>{('location' in innerData && innerData.location[0] && 'name' in innerData.location[0]) && innerData.location[0].name}</td>
            //                     <td>{('call_from' in innerData) && checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(innerData.call_from?.toString()))}</td>
            //                     <td>{('call_to' in innerData) && checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(innerData.call_to?.toString()))}</td>
            //                     <td>{('call_forward_to' in innerData && (innerData.call_forward_to)) && checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(innerData.call_forward_to?.toString()))}</td>
            //                     <td>{('initiated' in innerData) && timeFormat(innerData.initiated)}</td>
            //                     <td>{('acknowledged' in innerData) && timeFormat(innerData.acknowledged)}</td>
            //                     <td>{('start' in innerData && 'end' in innerData) ? (Duration(new Date(innerData.end), new Date(innerData.start))) : "-"}</td>
            //                 </tr>
            //             </>
            //         ))
            //         }
            //     </tbody>
            // </table>
        )
    }, [checkValueIsPhoneNumber, timeFormat]);

    // To expand the rows defaultly
    // const rowPreExpanded = (row: any) => ('total_count' in row);
    return (
        <>
            <Container fluid>
                <TopHeader
                    heading="Report"
                    to="dashboard"
                />

                <DataTable
                    columns={columns}
                    data={data}
                    sortServer
                    onSort={handleSort}
                    progressPending={showLoader}
                    progressComponent={<AppLoaderTable />}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationResetDefaultPage={resetPaginationToggle}
                    subHeader
                    persistTableHead
                    subHeaderComponent={subHeaderComponent}
                    actions={ReportActions}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    expandableRows={true}
                    // expandableRowExpanded={rowPreExpanded}    // to expand the rows defaultly while opening the page.
                    expandableRowsComponent={ExpandedComponents}
                    expandOnRowClicked
                    onRowClicked={(row: any) => setExpandedCurrentRow(row)}
                    expandableRowExpanded={(row) => (row === currentExpandedRow)}
                    onRowExpandToggled={(bool, row: any) => setExpandedCurrentRow(row)}
                />

            </Container>
            {
                showReplayModal && (
                    <AppModal
                        title={"Replay call recordings"}
                        bodyText={""}
                        hideFooter={true}
                        showCloseButton={true}
                        closeButtonEventEmitter={() => {
                            setShowReplayModal(false);
                            setReplayCallReportInfo(undefined);
                            setCustomLoading(false);
                        }}
                        modalSize={"xl"}
                    >
                        <>
                            <div className="row">
                                {
                                    replayCallReportInfo?.data?.type && (
                                        <div className="col-12 col-sm-6 col-md-4 mb-2">
                                            <div className="row">
                                                <div className="col-12">
                                                    <b>Call type:</b>
                                                </div>
                                                <div className="col-12 app-overflow-break-word text-capitalize">{replayCallReportInfo?.data?.type}</div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    replayCallReportInfo?.data?.location && replayCallReportInfo?.data?.location?.name ? (
                                        <div className="col-12 col-sm-6 col-md-4 mb-2">
                                            <div className="row">
                                                <div className="col-12">
                                                    <b>Location:</b>
                                                </div>
                                                <div className="col-12 app-overflow-break-word">
                                                    {replayCallReportInfo?.data?.location?.name}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )
                                }

                                {replayCallReportInfo && replayCallReportInfo?.appendAcknowledgeInfo ? (
                                    <div className="col-12 col-sm-6 col-md-4 mb-2">
                                        <div className="row">
                                            <div className="col-12">
                                                <b>Acknowledged Agent:</b>
                                            </div>
                                            {replayCallReportInfo?.appendAcknowledgeInfo?.map((item: any, index: number) => (

                                                <div className="col-12 app-overflow-break-word"> {('start' in item && 'end' in item) && capitalizeFirstLetter(item?.agent[0]?.name)}</div>
                                            ))}
                                        </div>
                                    </div>
                                ) : (<></>)
                                }

                                {
                                    replayCallReportInfo?.data?.initiated && (
                                        <div className="col-12 col-sm-6 col-md-4 mb-2">
                                            <div className="row">
                                                <div className="col-12">
                                                    <b>Initiated time:</b>
                                                </div>
                                                <div className="col-12 app-overflow-break-word">
                                                    {timeFormat(replayCallReportInfo?.data?.initiated)}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    replayCallReportInfo?.data?.acknowledged && (
                                        <div className="col-12 col-sm-6 col-md-4 mb-2">
                                            <div className="row">
                                                <div className="col-12">
                                                    <b>Acknowledged time:</b>
                                                </div>
                                                <div className="col-12 app-overflow-break-word">
                                                    {timeFormat(replayCallReportInfo?.data?.acknowledged)}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    replayCallReportInfo?.data?.end && replayCallReportInfo?.data?.start ? (
                                        <div className="col-12 col-sm-6 col-md-4 mb-2">
                                            <div className="row">
                                                <div className="col-12">
                                                    <b>Call duration:</b>
                                                </div>
                                                <div className="col-12 app-overflow-break-word">
                                                    {Duration(
                                                        new Date(replayCallReportInfo?.data?.end),
                                                        new Date(replayCallReportInfo?.data?.start)
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )
                                }
                                {
                                    replayCallReportInfo?.data?.call_from && (
                                        <div className="col-12 col-sm-6 col-md-4 mb-2">
                                            <div className="row">
                                                <div className="col-12">
                                                    <b>Call from:</b>
                                                </div>
                                                <div className="col-12 app-overflow-break-word">
                                                    {
                                                        checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(replayCallReportInfo?.data?.call_from?.toString()))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    replayCallReportInfo.data.call_to && (
                                        <div className="col-12 col-sm-6 col-md-4 mb-2">
                                            <div className="row">
                                                <div className="col-12">
                                                    <b>Call to:</b>
                                                </div>
                                                <div className="col-12 app-overflow-break-word">
                                                    {
                                                        checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(replayCallReportInfo?.data?.call_to?.toString()))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    replayCallReportInfo?.data?.call_forward_to && (
                                        <div className="col-12 col-sm-6 col-md-4 mb-2">
                                            <div className="row">
                                                <div className="col-12">
                                                    <b>Call Forward Number:</b>
                                                </div>
                                                <div className="col-12 app-overflow-break-word">
                                                    {PhoneNumberFormatter(
                                                        replayCallReportInfo?.data?.call_forward_to
                                                            .toString()
                                                            .slice(1),
                                                        replayCallReportInfo?.data?.call_forward_to?.toString().slice(1)
                                                            .length
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                            <div
                                className={
                                    replayCallReportInfo?.data?.type === "voice"
                                        ? "call-replay-audio-player-container d-flex align-items-center justify-content-center"
                                        : "call-replay-video-player-container d-flex align-items-center justify-content-center"
                                }
                            >
                                {replayCallReportInfo?.data?.mediaUrl ? (
                                    <>
                                        {replayCallReportInfo?.data?.type && (
                                            <>
                                                {replayCallReportInfo?.data?.type === "voice" ? (
                                                    <audio
                                                        controls
                                                        src={replayCallReportInfo?.data?.mediaUrl}
                                                    ></audio>
                                                ) : (
                                                    <video
                                                        className={"call-replay-video-player"}
                                                        src={replayCallReportInfo?.data?.mediaUrl}
                                                        controls
                                                    ></video>
                                                )}
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <></>
                                )}
                            </div>
                            <div className="mt-4 d-flex align-items-center justify-content-center">
                                <button className="btn app-button-color">
                                    <a
                                        className="app-button-text-color app-text-decoration-none"
                                        target="_blank"
                                        href={replayCallReportInfo?.data?.mediaUrl}
                                        download="video"
                                    >
                                        Download
                                    </a>
                                </button>
                            </div>
                        </>
                    </AppModal>
                )
            }
        </>
    );
};

export default ReportDetails;
